const color = {
  // --- New modern "gold + deep contrast" tokens ---
  surface: "#FAF8F4", // page background – ivory
  surfaceAlt: "#FFFFFF", // cards / raised surfaces
  dark: "#201A12", // espresso – header / footer / buttons
  darkAlt: "#2C241A", // slightly lighter espresso (hover on dark)
  text: "#17130E", // primary text
  textMuted: "#6B6257", // secondary text
  line: "#ECE7DE", // borders / dividers
  accentDark: "#A9791F", // gold hover

  // --- Legacy keys (kept so existing references keep working) ---
  primary: "#FAF8F4", // was LightGold bg -> now ivory surface
  primary_medium: "#EDE6DA", // MediumGold
  primary_dark: "#D9CFC1", // DarkGold
  accent: "#C6912E", // refined gold accent
  btn_dark: "#201A12", // was #79590E -> now espresso (buttons / icons)
  secondary: "#000000",
  secondaryDark: "#58595b",
  black: "#17130E",
  white: "#FFFFFF",
  red: "#E21D39",
};

export default color;
